import {Stack, styled} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components/CTAButtonFixed';

const CustomCTAButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
`;

const StyledCard = styled(Stack)`
	padding: 16px;
	border-radius: 8px;
	gap: 8px;

	background-color: ${({theme}) => theme.colors.brand.primary.white};
`;

export {CustomCTAButtonFixedAction, StyledCard};
